import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    // Public nav
    "nav.home": "Accueil",
    "nav.services": "Services",
    "nav.events": "Evenementiel",
    "nav.login": "Se connecter",
    "nav.quote": "Demander un devis",
    // Hero / Landing
    "landing.title": "Organisez des evenements exceptionnels",
    "landing.subtitle": "Plateforme complete pour la gestion evenementielle : inscriptions, billetterie, QR codes et statistiques en temps reel.",
    "landing.cta": "Demander un acces gratuit",
    "landing.login": "Deja un compte ?",
    "landing.login_link": "Se connecter",
    "landing.features_title": "Tout ce dont vous avez besoin",
    "landing.features_subtitle": "Une solution complete pour vos evenements",
    "landing.feat_events": "Creation d'evenements",
    "landing.feat_events_desc": "Creez et gerez vos evenements en quelques clics. Titre, dates, lieu, capacite, tout est personnalisable.",
    "landing.feat_inscriptions": "Inscriptions en ligne",
    "landing.feat_inscriptions_desc": "Formulaire personnalisable. Collectez les informations dont vous avez besoin pour chaque participant.",
    "landing.feat_qr": "QR Codes securises",
    "landing.feat_qr_desc": "Chaque participant recoit un QR Code unique. Controle d'acces rapide et fiable a l'entree.",
    "landing.feat_scanner": "Scanner mobile",
    "landing.feat_scanner_desc": "Scannez les QR Codes depuis un smartphone. Validation instantanee avec indicateur visuel vert/orange/rouge.",
    "landing.feat_stats": "Statistiques temps reel",
    "landing.feat_stats_desc": "Suivez en direct le nombre d'inscrits, de presents, le taux de participation et les categories.",
    "landing.feat_comms": "Communications",
    "landing.feat_comms_desc": "Envoyez confirmations, rappels et notifications a vos participants directement depuis la plateforme.",
    // Event landing
    "event.hero.title": "Organisez des evenements exceptionnels",
    "event.hero.subtitle": "Plateforme complete pour la gestion evenementielle : inscriptions, billetterie, QR codes et statistiques en temps reel.",
    "event.hero.cta": "Demander un acces gratuit",
    "event.hero.login": "Deja un compte ?",
    "event.hero.login_link": "Se connecter",
    // Public event page
    "event.public.back": "Tous les evenements",
    "event.public.share_whatsapp": "Partager via WhatsApp",
    "event.public.copy_link": "Copier le lien",
    "event.public.link_copied": "Lien copie !",
    "event.public.ticketing": "Billetterie",
    "event.public.available": "disponible(s)",
    "event.public.tickets": "billet(s)",
    "event.public.pay": "Payer",
    "event.public.redirecting": "Redirection vers le paiement...",
    "event.public.secure_payment": "Paiement securise par Stripe",
    "event.public.free_registration": "Inscription gratuite",
    "event.public.register_btn": "S'inscrire gratuitement",
    "event.public.registration_success": "Inscription confirmee !",
    "event.public.registration_success_msg": "Vous recevrez un email de confirmation avec votre QR code d'acces.",
    "event.public.share_on_wa": "Partager sur WhatsApp",
    "event.public.not_found": "Evenement introuvable",
    "event.public.not_found_msg": "Cet evenement n'existe pas ou n'est plus disponible.",
    "event.public.back_events": "Retour aux evenements",
    "event.public.buyer_email": "Votre email (pour recevoir les billets)",
    // QuotePage
    "quote.title": "Demander un devis",
    "quote.step1": "Service",
    "quote.step2": "Details",
    "quote.step3": "Contact",
    "quote.select_service": "Quel service vous interesse ?",
    "quote.next": "Suivant",
    "quote.prev": "Precedent",
    "quote.submit": "Envoyer la demande",
    "quote.sending": "Envoi en cours...",
    "quote.success_title": "Demande envoyee !",
    "quote.success_msg": "Notre equipe reviendra vers vous sous 24 a 48h.",
    // Form fields
    "form.first_name": "Prenom",
    "form.last_name": "Nom",
    "form.email": "Email",
    "form.phone": "Telephone",
    "form.organization": "Organisation (optionnel)",
    "form.required": "obligatoire(s)",
    "form.name": "Nom complet",
    "form.company": "Entreprise / Organisation",
    "form.city": "Ville",
    "form.message": "Details du projet",
    // Payment result
    "payment.checking": "Verification du paiement...",
    "payment.wait": "Veuillez patienter quelques instants.",
    "payment.success": "Paiement reussi !",
    "payment.confirmed": "Votre billet a ete confirme.",
    "payment.email_qr": "Vous recevrez un email de confirmation avec votre QR code d'acces.",
    "payment.cancelled": "Paiement annule",
    "payment.cancelled_msg": "Votre paiement a ete annule. Aucun montant n'a ete debite.",
    "payment.error": "Erreur de paiement",
    "payment.error_msg": "Une erreur est survenue. Veuillez reessayer ou contacter le support.",
    "payment.back": "Retour aux evenements",
    // Footer
    "footer.rights": "Tous droits reserves",
    "footer.legal": "Mentions legales",
    "footer.privacy": "Confidentialite",
    "footer.cookies": "Cookies",
    // Signup form
    "signup.step1": "Organisation",
    "signup.step2": "Besoin",
    "signup.step3": "Personnalisation",
    "signup.step4": "Validation",
  },
  en: {
    // Public nav
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.events": "Events",
    "nav.login": "Sign in",
    "nav.quote": "Request a quote",
    // Hero / Landing
    "landing.title": "Organize exceptional events",
    "landing.subtitle": "Complete platform for event management: registration, ticketing, QR codes and real-time analytics.",
    "landing.cta": "Request free access",
    "landing.login": "Already have an account?",
    "landing.login_link": "Sign in",
    "landing.features_title": "Everything you need",
    "landing.features_subtitle": "A complete solution for your events",
    "landing.feat_events": "Event creation",
    "landing.feat_events_desc": "Create and manage your events in a few clicks. Title, dates, venue, capacity, everything is customizable.",
    "landing.feat_inscriptions": "Online registration",
    "landing.feat_inscriptions_desc": "Customizable form. Collect the information you need for each attendee.",
    "landing.feat_qr": "Secure QR Codes",
    "landing.feat_qr_desc": "Each attendee receives a unique QR Code. Fast and reliable access control at the entrance.",
    "landing.feat_scanner": "Mobile scanner",
    "landing.feat_scanner_desc": "Scan QR Codes from a smartphone. Instant validation with green/orange/red visual indicators.",
    "landing.feat_stats": "Real-time analytics",
    "landing.feat_stats_desc": "Track live registrations, attendance, participation rate and categories.",
    "landing.feat_comms": "Communications",
    "landing.feat_comms_desc": "Send confirmations, reminders and notifications to your attendees directly from the platform.",
    // Event landing
    "event.hero.title": "Organize exceptional events",
    "event.hero.subtitle": "Complete platform for event management: registration, ticketing, QR codes and real-time analytics.",
    "event.hero.cta": "Request free access",
    "event.hero.login": "Already have an account?",
    "event.hero.login_link": "Sign in",
    // Public event page
    "event.public.back": "All events",
    "event.public.share_whatsapp": "Share via WhatsApp",
    "event.public.copy_link": "Copy link",
    "event.public.link_copied": "Link copied!",
    "event.public.ticketing": "Tickets",
    "event.public.available": "available",
    "event.public.tickets": "ticket(s)",
    "event.public.pay": "Pay",
    "event.public.redirecting": "Redirecting to payment...",
    "event.public.secure_payment": "Secure payment by Stripe",
    "event.public.free_registration": "Free registration",
    "event.public.register_btn": "Register for free",
    "event.public.registration_success": "Registration confirmed!",
    "event.public.registration_success_msg": "You will receive a confirmation email with your QR code access.",
    "event.public.share_on_wa": "Share on WhatsApp",
    "event.public.not_found": "Event not found",
    "event.public.not_found_msg": "This event does not exist or is no longer available.",
    "event.public.back_events": "Back to events",
    "event.public.buyer_email": "Your email (to receive tickets)",
    // QuotePage
    "quote.title": "Request a quote",
    "quote.step1": "Service",
    "quote.step2": "Details",
    "quote.step3": "Contact",
    "quote.select_service": "Which service interests you?",
    "quote.next": "Next",
    "quote.prev": "Previous",
    "quote.submit": "Send request",
    "quote.sending": "Sending...",
    "quote.success_title": "Request sent!",
    "quote.success_msg": "Our team will get back to you within 24 to 48 hours.",
    // Form fields
    "form.first_name": "First name",
    "form.last_name": "Last name",
    "form.email": "Email",
    "form.phone": "Phone",
    "form.organization": "Organization (optional)",
    "form.required": "required",
    "form.name": "Full name",
    "form.company": "Company / Organization",
    "form.city": "City",
    "form.message": "Project details",
    // Payment result
    "payment.checking": "Checking payment...",
    "payment.wait": "Please wait a moment.",
    "payment.success": "Payment successful!",
    "payment.confirmed": "Your ticket has been confirmed.",
    "payment.email_qr": "You will receive a confirmation email with your QR access code.",
    "payment.cancelled": "Payment cancelled",
    "payment.cancelled_msg": "Your payment has been cancelled. No amount has been charged.",
    "payment.error": "Payment error",
    "payment.error_msg": "An error occurred. Please try again or contact support.",
    "payment.back": "Back to events",
    // Footer
    "footer.rights": "All rights reserved",
    "footer.legal": "Legal notice",
    "footer.privacy": "Privacy",
    "footer.cookies": "Cookies",
    // Signup form
    "signup.step1": "Organization",
    "signup.step2": "Requirements",
    "signup.step3": "Customization",
    "signup.step4": "Validation",
  },
};

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => localStorage.getItem("glotech_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("glotech_lang", locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const t = (key) => translations[locale]?.[key] || translations.fr[key] || key;

  return (
    <I18nContext.Provider value={{ locale, setLocale, t, availableLocales: ["fr", "en"] }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export function LanguageSwitcher({ className = "" }) {
  const { locale, setLocale } = useI18n();
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="language-switcher">
      {["fr", "en"].map(l => (
        <button
          key={l}
          onClick={() => setLocale(l)}
          className={`px-2 py-1 rounded text-xs font-medium transition-colors ${locale === l ? "bg-[#0099CC] text-white" : "text-[#64748b] hover:text-white"}`}
          data-testid={`lang-${l}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
